export default __webpack_public_path__ + "static/media/wallpaperflare.com_wallpaper (12).c6319e27.jpg";